/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable valid-jsdoc */
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookie from 'cookies-js';
import Cookies from 'js-cookie';
import jwt from 'jsonwebtoken';

import notificationIcon from '../../../template/utils/icons/notification.png';
import profileIcon from '../../../template/utils/images/profile.png';
import { deleteWarningMessages } from '../../../actions/auth.actions/user.login.action';
import logoutAction from '../../../actions/auth.actions/logout.action';
import InfoAlertNotification from '../../commons/InfoAlertNotification';
import fetchUserNotification from '../../../actions/notification.actions/getUserNotification';

/**
 * @class UserDashBoardTopNavigation
 */
class UserDashBoardTopNavigation extends Component {
  state = {
    authCard: '',
    authAcct: ''
  }

  componentDidMount = () => {
    const getBvn = Cookie.get('getB');
    const isAccount = Cookie.get('isA');
    const token = Cookie.get('jwtToken');
    const decodeUser = jwt.decode(token);


    const email = decodeUser === null ? '' : decodeUser.email;
    if (email) {
      const { FetchUserNotification, history } = this.props;
      FetchUserNotification(email, history);
      this.setState({
        authCard: getBvn,
        authAcct: isAccount
      });
    }
  }

  /**
   * @description handle user log out
   *
   * @param {Object} event logout event object
   *
   *
   * @returns {undefined} calls logoutProps
   */
  onLogout = (event) => {
    const { logoutUser } = this.props;
    const { history } = this.props;
    event.preventDefault();
    logoutUser(history.push('/'));
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const { userNotification } = this.props;
    const { authCard, authAcct } = this.state;
    const notificationLength = userNotification.length;
    const notSetCardMessage = 'You\'re yet to set up your card details';
    const notSetAcctMessage = 'You\'re yet to set up your account details';
    const userName = Cookie.get('username');
    const userObj = Cookies.getJSON('userObj');
    const userDashBoardTopNavigation = (
      <section>
        <div className="dash_main_page_wrappper">
          <div className="dash_top_nav">
            <div className="dashboard_sideNav_open">
              <button type="button">
                        &#9776;
              </button>
            </div>
            {
              authCard !== 'true' ? (
                <InfoAlertNotification
                  message={notSetCardMessage}
                  onClick={this.handleDelete}
                />
              ) : authAcct !== 'true' ? (
                <InfoAlertNotification
                  message={notSetAcctMessage}
                  onClick={this.handleDelete}
                />
              ) : (
                <InfoAlertNotification
                  onClick={this.handleDelete}
                />
              )
                      }
            <div className="nav_functions">
              <div className="notification_bell">
                <div className="bell_icon">
                  {
                    notificationLength > 0 ? (
                      <>
                        <div className="popover__wrapper">
                          <Link
                            to="/user-notification"
                          >
                            < >
                              <img
                                src={notificationIcon}
                                alt=""
                                id="notifigImg"
                              />
                              <div className="status_dot" />
                              <div className="popover__content">
                                <p
                                  className="popover__message"
                                >
                                  {`You have ${notificationLength} notifications.`}

                                </p>
                              </div>
                            </>
                          </Link>
                        </div>
                      </>
                    ) : (
                      <img src={notificationIcon} alt="" />
                    )
                  }
                </div>
              </div>

              <div className="dropdown">
                <div className="user_image">
                  {
                  userObj ? userObj.photoUrl ? (
                    <img src={userObj.photoUrl} alt="" />
                  ) : (
                    <img src={profileIcon} alt="" />
                  ) : ''
                }


                </div>
                <div className="dropdown-toggle account_functions" data-toggle="dropdown">
                  <div className="user_name">
                    <p style={{
                      fontWeight: '120px',
                      fontSize: '16px'
                    }}
                    >
                      { userName }
                    </p>

                    <p style={{
                      color: '#014886'
                    }}
                    >
                            Manage Account
                    </p>
                  </div>
                </div>
                <div className="dropdown-menu animated bounce">
                  <Link className="dropdown-item" to="/user-profile">
                    <i className="fas fa-user" />
                    {' '}
                                Profile
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/change-password"
                  >
                    <i className="fas fa-lock" />
                    {' '}
                                Change Password
                  </Link>
                  <Link className="dropdown-item" to="/know-your-customer">
                    <i className="fas fa-cog" />
                    {' '}
                                Set Up KYC
                  </Link>
                  <Link
                    className="dropdown-item nav_item_logout"
                    to="#"
                    onClick={this.onLogout}
                  >
                    <i className="fas fa-power-off" />
                    {' '}
                                    Logout
                  </Link>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>
    );
    return (
      <>{userDashBoardTopNavigation}</>
    );
  }
}
UserDashBoardTopNavigation.propTypes = {
  logoutUser: PropTypes.func,
  history: PropTypes.shape({}),
  FetchUserNotification: PropTypes.func,
  userNotification: PropTypes.any,
  user: PropTypes.any
};

const mapStateToProps = state => ({
  message: state.loginReducer.warningMessage,
  userNotification: state.allUserNotification.userNotification,
  user: state.loginReducer.user
});

const mapDispatchToProps = dispatch => ({
  DeleteWarningMessage: () => dispatch(deleteWarningMessages()),
  logoutUser: () => dispatch(logoutAction()),
  FetchUserNotification: userEmail => dispatch(fetchUserNotification(userEmail)),
});

export default withRouter(connect(mapStateToProps,
  mapDispatchToProps)(UserDashBoardTopNavigation));
